import { Component, Input, OnInit } from '@angular/core';
import { BaseFormComponent } from './base-form.component';

@Component({ template: '' })
export abstract class BaseFormMobileComponent<T = unknown> extends BaseFormComponent<T> implements OnInit {
  @Input() labelPosition = 'floating';
  @Input() suggested?: boolean;
}
